import React, { useEffect, useState } from 'react';
import { InventoryManagment } from "../containers/Inventory/Pages/InventoryManagment";
import { AddStockFormPage } from '../containers/Inventory/Pages/AddStockFormPage';

export function InventoryPage(){
    return (
        <InventoryManagment />
    )
}